import React, { useState } from 'react';
import axios from 'axios';
import { baseAPI } from '../../config';
import { toast } from 'react-toastify';
import userStore from '../../store/userStore';

const ExpedientsPermissionSwitch = ({ userData, isLoading = false }) => {
  const { user: currentUser } = userStore();
  const [canOperateAllExpedients, setCanOperateAllExpedients] = useState(userData?.operators_handle_all);

  const handleToggle = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      };

      const newValue = !canOperateAllExpedients;

      await axios.post(
        `${baseAPI}/users/update/${userData?._id}`,
        {
          operators_handle_all: newValue || false,
        },
        { headers }
      );

      toast.success(
        newValue
          ? 'Los usuarios ahora pueden operar con todos los expedientes'
          : 'Los usuarios pueden operar con los expedientes asignados'
      );

      setCanOperateAllExpedients(newValue);
    } catch (error) {
      console.error('Error updating expedients permission:', error);
      toast.error(error.response?.data?.message || 'Error al actualizar los permisos', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  // Lo gestionan admin y company (esta tarjeta solo se renderiza en cuentas
  // company). El backend valida quién puede guardar en /users/update/:id.
  const canManage = currentUser?.role === 'admin' || currentUser?.role === 'company';

  if (isLoading || !canManage) {
    return null;
  }

  return (
    <div className='mb-6 p-4 rounded-lg border border-slate-200'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center'>
          <span className='text-sm font-medium text-slate-700 mr-3'>
            Los usuarios pueden operar con todos los expedientes
          </span>
        </div>
        <button
          onClick={handleToggle}
          disabled={isLoading}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ${
            canOperateAllExpedients ? 'bg-blue-600' : 'bg-slate-200'
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              canOperateAllExpedients ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
      </div>
    </div>
  );
};

export default ExpedientsPermissionSwitch;
